/**
 * Created by JIocb on 25.05.2017.
 */
namespace Factive.Game {
    import InteractionEvent = PIXI.interaction.InteractionEvent;
    import Slot = dragonBones.Slot;
    import SoundManager = Factive.Core.ISoundManager;
    export enum ButtonState
    {
        UP,
        OVER,
        DOWN
    };

    export class DragonBonesButton
    {

        protected _dc: Factive.Core.DependenciesContainer;
        private _armature:dragonBones.Armature;
        private _states:Array<PIXI.DisplayObject> = [];
        private _sndByState:Object = {};
        private _hitArea:PIXI.DisplayObject;
        private _sm: Factive.Core.ISoundManager;

        public constructor(armature:dragonBones.Armature,dc:Factive.Core.DependenciesContainer)
        {
            this._dc = dc;
            this._armature = armature;
            var hiAreaSlot:dragonBones.Slot = this._armature.getSlot("hitArea");
            this._hitArea = hiAreaSlot.display;
            this._sm = this._dc.get("SoundManager");
            this.build(this._armature.getSlot("up"),this._armature.getSlot("over"),this._armature.getSlot("down"));
            this.setState(ButtonState.UP);

        }

        protected build(upSlot:dragonBones.Slot,overSlot:dragonBones.Slot,downSlot:dragonBones.Slot)
        {
            var up:PIXI.DisplayObject = (upSlot!=null) ? upSlot.display : null;
            var over:PIXI.DisplayObject = (overSlot!=null) ? overSlot.display : null;
            var down:PIXI.DisplayObject = (downSlot!=null) ? downSlot.display : null;;

            this._states[ButtonState.UP] = up || over || down;
            this._states[ButtonState.OVER] = over || down || up;
            this._states[ButtonState.DOWN] = down || over || up  ;

            this._sndByState[ButtonState.OVER] = SoundConstants.BUTTON_ROLLOVER;
            this._sndByState[ButtonState.DOWN] = SoundConstants.BUTTON_CLICK;

            this.enableInput(true);

            this._hitArea.addListener("mouseover",this.handleMouseEvent,this);
            this._hitArea.addListener("mouseout",this.handleMouseEvent,this);
            this._hitArea.addListener("tap",this.handleMouseEvent,this);
            this._hitArea.addListener("click",this.handleMouseEvent,this);
            this._hitArea.addListener("pointerdown",this.handleMouseEvent,this);
            this._hitArea.addListener("pointerup",this.handleMouseEvent,this);
        };

        protected handleMouseEvent(evt:InteractionEvent )
        {
            switch(evt.type)
            {
                case "pointerdown":{
                    this._sm.playSound(this._sndByState[ButtonState.DOWN]);
                    this.setState(ButtonState.OVER);
                    break;}
                case "pointerup":{
                    this.setState(ButtonState.UP);
                    break;}
                case "mouseover":{
                    this._sm.playSound(this._sndByState[ButtonState.OVER]);
                    this.setState(ButtonState.OVER);
                    break;}
                case "mouseout":{
                    this.setState(ButtonState.UP);
                    break;}
            }
        };


        public addOverSound(sndName:string):void
        {
            this._sndByState[ButtonState.OVER] = sndName;
        };

        public addPressSound(sndName:string):void
        {
            this._sndByState[ButtonState.DOWN] = sndName;
        };

        protected setState(type:number)
        {
            var l = this._states.length;

            if(type>=l) return;

            for (var i = 0; i < l; i++)
            {
                this._states[i].visible = false;
            }
            this._states[type].visible = true;
        };

        public addPressListener(fn: Function,context?:any)
        {
            this._hitArea.addListener("pointerup",fn,context);
        }


        public enableInput(value: boolean)
        {
            this._hitArea.visible = value;
            this._hitArea.interactive = value;
            this._hitArea.buttonMode = value;
            this.setState(ButtonState.UP);
            this._states[ButtonState.UP].alpha = value ? 1:.4;
        }
        public removePressListener(fn: Function,context?:any)
        {
            this._hitArea.removeListener("pointerup",fn,context);
        }

        // private _labelStyle:PIXI.TextStyle;

        public addLabel(text:string,dx?:number,dy?:number,style?: PIXI.TextStyle):void
        {

            if(style)
            {

                var fs:number = <number>style.fontSize*2;
                style.fontSize = fs;
            }

            this._armature["label_style"] = this._armature["label_style"] || style;

            var label = this._armature["label"]
            if(label)
            {
                this._armature.display.removeChild(label)
            }

            label = new PIXI.Text(text, this._armature["label_style"]);
            label.anchor.set(.5,.5);
            label.x = dx || 0;
            label.y = dy || 0;

            this._armature.display.addChild(label)
            this._armature["label"] = label;

            if(style)
            {
                label.scale.x = label.scale.y = .5;

            }
            if(label.width > this._hitArea.width - 15*this._dc.get("AssetScale")){
                label.width = this._hitArea.width - 15*this._dc.get("AssetScale");
            }
        };

        public destroy()
        {
            //this._hitArea.removeAllListeners();
            this._hitArea.removeListener("mouseover",this.handleMouseEvent,this);
            this._hitArea.removeListener("mouseout",this.handleMouseEvent,this);
            this._hitArea.removeListener("tap",this.handleMouseEvent,this);
            this._hitArea.removeListener("click",this.handleMouseEvent,this);
            this._hitArea.removeListener("pointerdown",this.handleMouseEvent,this);
            this._hitArea.removeListener("pointerup",this.handleMouseEvent,this);

            var label = this._armature["label"]
            if(label)
            {
                this._armature.display.removeChild(label)
            }

            this._armature["label"] = null;
            this._armature["label_style"] = null;
            this._armature = null;
        }
    }
}


// WEBPACK FOOTER //
// src/typescript/Game/Views/Controls/DragonBonesButton.ts